import { getTheme } from "PFCore/get_theme";
import { create } from "zustand";
import { immer } from "zustand/middleware/immer";
import { useShallow } from "zustand/react/shallow";

import { AppShellStore } from "./app_shell_store_types";

const INITIAL_STATE = {
  themeVars: getTheme(),
  termsShown: false
};

export const useAppShellStore = create<AppShellStore>()(
  immer((set) => ({
    ...INITIAL_STATE,
    actions: {
      showTerms: () =>
        set((state) => {
          state.termsShown = true;
        }),
      hideTerms: () =>
        set((state) => {
          state.termsShown = false;
        }),
      reset: () =>
        set((state) => {
          Object.assign(state, INITIAL_STATE);
        })
    }
  }))
);

export const useAppShellStoreActions = () => useAppShellStore(useShallow((state) => state.actions));
